var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "loginOTP" } },
    [
      _c(
        "v-container",
        { staticClass: "fill-height", attrs: { fluid: "" } },
        [
          _c(
            "v-row",
            { attrs: { align: "center", justify: "center" } },
            [
              _c(
                "v-col",
                { attrs: { cols: "12", sm: "8", md: "8" } },
                [
                  _c("v-img", {
                    staticClass: "mt-8 tl_logo",
                    staticStyle: { margin: "auto" },
                    attrs: {
                      src: require("../assets/img/logo-tl.png"),
                      width: "80"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "v-row",
            { attrs: { align: "center", justify: "center" } },
            [
              _c(
                "v-col",
                {
                  staticClass: "login_slim",
                  attrs: { cols: "12", sm: "8", md: "3" }
                },
                [
                  _c(
                    "v-card",
                    { staticClass: "login_card", attrs: { elevation: "10" } },
                    [
                      _c(
                        "v-card-text",
                        { staticClass: "login" },
                        [
                          _c(
                            "v-row",
                            { attrs: { align: "center", justify: "center" } },
                            [
                              _c(
                                "v-col",
                                { attrs: { cols: "12", sm: "6", md: "12" } },
                                [
                                  _c(
                                    "h1",
                                    {
                                      staticStyle: {
                                        "font-size": "22px !important"
                                      },
                                      attrs: { align: "center" }
                                    },
                                    [
                                      _vm._v(
                                        " Vložte prosím " +
                                          _vm._s(
                                            _vm.zahranicnaOsoba
                                              ? "povolenie na pobyt"
                                              : "občiansky preukaz"
                                          ) +
                                          " "
                                      )
                                    ]
                                  ),
                                  _c(
                                    "h1",
                                    {
                                      staticStyle: {
                                        "font-size": "22px !important"
                                      },
                                      attrs: { align: "center" }
                                    },
                                    [
                                      _vm._v(
                                        " pre " +
                                          _vm._s(_vm.cisloObchPripadu) +
                                          " "
                                      )
                                    ]
                                  )
                                ]
                              )
                            ],
                            1
                          ),
                          _c(
                            "v-row",
                            [
                              _c(
                                "v-col",
                                { attrs: { cols: "12", sm: "12" } },
                                [
                                  _c("upload-area", { ref: "refuploadarea" }),
                                  _c("v-divider", { staticClass: "my-20px" }),
                                  _c(
                                    "v-btn",
                                    {
                                      staticClass: "btn-primary",
                                      attrs: { disabled: _vm.uloadujemData },
                                      on: {
                                        click: function($event) {
                                          return _vm.dmsSave()
                                        }
                                      }
                                    },
                                    [
                                      _c("v-icon", { attrs: { left: "" } }, [
                                        _vm._v(" mdi-upload-outline ")
                                      ]),
                                      _vm._v(" Nahrať ")
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "v-row",
            { attrs: { align: "center", justify: "center" } },
            [
              _c(
                "v-col",
                {
                  staticClass: "v-copyright",
                  attrs: { align: "center", cols: "12", sm: "8", md: "8" }
                },
                [
                  _vm._v(" V spolupráci s "),
                  _c("b", [_vm._v("NCC a.s.")]),
                  _vm._v(" © 2020 ")
                ]
              )
            ],
            1
          ),
          _c(
            "v-snackbar",
            {
              class: {
                "snack-ok": _vm.snackbar.error === 0,
                "snack-error": _vm.snackbar.error > 0
              },
              attrs: { timeout: _vm.snackbar.timeout },
              scopedSlots: _vm._u([
                {
                  key: "action",
                  fn: function(ref) {
                    var attrs = ref.attrs
                    return [
                      _c(
                        "v-btn",
                        _vm._b(
                          {
                            staticClass: "link",
                            attrs: { elevation: "0" },
                            on: {
                              click: function($event) {
                                _vm.snackbar.show = false
                              }
                            }
                          },
                          "v-btn",
                          attrs,
                          false
                        ),
                        [_vm._v(" Zavrieť ")]
                      )
                    ]
                  }
                }
              ]),
              model: {
                value: _vm.snackbar.show,
                callback: function($$v) {
                  _vm.$set(_vm.snackbar, "show", $$v)
                },
                expression: "snackbar.show"
              }
            },
            [_vm._v(" " + _vm._s(_vm.snackbar.text) + " ")]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }